import React, { useState } from "react"
import PropTypes from "prop-types"

const SearchInput = props => {
  const {
    placeholder,
    onFocus,
    onBlur,
    onSearchSubmit,
    style,
    searchTerm,
    onChange,
    filterValidation,
    updateFilterValidation,
  } = props

  const [searchLengthValidation, setSearchLengthValidation] = useState(false)

  const onKeyDown = e => {
    if (e.key === "Enter" && searchTerm) {
      onSearchSubmit()
    }
  }

  return (
    <div className={style?.formContainer}>
      <div className={style?.form}>
        <input
          placeholder={placeholder}
          value={searchTerm || ""}
          onChange={onChange}
          className={style?.input}
          autoComplete="on"
          onFocus={onFocus}
          onBlur={onBlur}
          data-action-detail={searchTerm}
          onKeyDown={onKeyDown}
          name="search-box"
        ></input>
        <span
          onClick={() => {
            if (searchTerm?.length < 3) {
              setSearchLengthValidation(true)
              updateFilterValidation()
              return
            }
            setSearchLengthValidation(false)
            onSearchSubmit()
          }}
          className={`${style?.image} icon-search`}
        />
      </div>
      {searchLengthValidation && !filterValidation && (
        <p className={style?.validationError}>
          Please enter a search term or select filter options
        </p>
      )}
    </div>
  )
}

SearchInput.propTypes = {
  placeholder: PropTypes.string,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  onSearchSubmit: PropTypes.func,
  style: PropTypes.object,
  searchTerm: PropTypes.string,
  onChange: PropTypes.func,
  searchType: PropTypes.string,
  filterValidation: PropTypes.bool,
  updateFilterValidation: PropTypes.func,
}

export default SearchInput
